import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'

const GeneralPhilosophyInstructions = () => {
  return (
    <div className="flex flex-col gap-4 ">
      <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
        La philosophie générale des séjours lec à l’étranger
      </Typography>
      <Typography variant="secondary-body" color={tailwindColors.grey.lighter}>
        Merci de lire attentivement le texte ci-dessous. Il engage à la fois le participant et ses
        parents.
      </Typography>
      <InnerBox className="bg-white-hover rounded-lg p-4 border border-primary-light">
        <ol className="list-decimal pl-5 text-sm text-grey flex flex-col gap-4">
          <li>
            <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
              Les familles-hôtesses vous reçoivent en tant que membre de leur famille à part
              entière. Elles ne sont ni un hôtel ni un service de taxi. Vos efforts d’intégration,
              votre participation active à leurs activités familiales, votre sourire, votre «merci»
              et surtout l’enthousiasme dont vous faites preuve constituent la meilleure récompense
              de leurs efforts. Elles vous reçoivent car elles ont un vif désir de favoriser les
              relations internationales et souhaitent mieux connaître votre pays à travers vous.
              Vous devez donc prendre l’engagement d’un très bon comportement dans votre
              famille-hôtesse.
            </Typography>
          </li>
          <li>
            <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
              Les sorties le soir sont strictement interdites (même si des sorties ont été
              autorisées sur le bulletin d’inscription que vous avez envoyé). Par contre, les
              sorties le soir en compagnie de la famille-hôtesse sont fortement conseillées.
            </Typography>
          </li>
          <li>
            <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
              La consommation et la possession d’alcool, de cigarettes, de cigarette électronique,
              de marijuana ou tout autre produit stupéfiant est illégale pour toute personne âgée
              de moins de 21 ans. Il est également strictement interdit d’aller dans des
              établissements disposant d’une licence de débit de boissons (bars, boîtes de nuit,
              etc.). Si vous enfreignez ces règles, qui s’appliquent à l’ensemble des jeunes en
              séjour avec LEC, vous vous exposez à un renvoi immédiat en France aux frais de vos
              parents.
            </Typography>
          </li>
          <li>
            <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
              Vous devez vous efforcer de chercher le contact avec la famille en laissant ainsi
              après votre départ une bonne impression de vous-même et implicitement de la France.
              Vous vous engagez aussi à ne pas emprunter d’argent à votre famille et à toujours
              payer votre part lors d’une sortie avec la famille
            </Typography>
          </li>

          <li>
            <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
              La conduite d’un véhicule à moteur, quel qu’il soit, y compris la trottinette
              électrique, tout comme l’auto-stop, sont formellement interdits.
            </Typography>
          </li>
        </ol>
      </InnerBox>
    </div>
  )
}

export default GeneralPhilosophyInstructions
